import { configureStore } from "@reduxjs/toolkit";

import signUpReducer from "./signUpSlice";
import userReducer from "./userSlice";
import paymentReducer from "./paymentSlice";
import pageSideBarSlice from "./pageSideBarSlice";

const store = configureStore({
  reducer: {
    signUp: signUpReducer,
    user: userReducer,
    payment: paymentReducer,
    pageSideBar: pageSideBarSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
